export enum AuthErrorCodes {
  Expired = 'EXPIRED_CODE',
  Invalid = 'INVALID_CODE',
  Blocked = 'AUTH_BLOCKED',
}

export type AuthError = {
  code: AuthErrorCodes;
  title: string;
  retryAfter?: number;
};

export type RestorePasswordResponse = {
  data: {
    message: string;
  };
};
